<template>
	<div class="box">
		<div class="padding h-100">
			<div class="refresh d-flex flex-row align-items-center" style="margin-top: -0.5rem;">
				<div class="flex">
					<a @click="loadData" class="text-muted no-select btn-subtle" v-tippy title="Refresh">
						<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
					</a>
				</div>
				<div class="mr-2 text-muted">Assessment:</div>
				<config-select style="width: 300px" :options="assessments" v-model="assessmentID" byField="id" />
			</div>
			<table v-if="assessmentID && stats && stats.length > 0" style="width: 100%;">
				<tr>
					<th class="text-muted">Class Progress</th>
					<!-- <th class="text-muted text-center">
						<i class="fas fa-file-alt fa-lg" v-tippy title="Unscored"></i>
					</th>
					<th class="text-muted text-center">
						<i class="fas fa-check fa-lg" v-tippy title="Scored Once"></i>
					</th>
					<th class="text-muted text-center">
						<i class="fas fa-check-double fa-lg" v-tippy title="Resolution"></i>
					</th>
					<th class="text-muted text-center">
						<i class="fas fa-shield-check fa-lg" v-tippy title="Complete"></i>
					</th>
					<th class="text-muted text-center">
						<i class="fas fa-badge fa-lg" v-tippy title="Total"></i>
					</th>-->
					<th></th>
				</tr>
				<tr v-for="stat in stats" :key="stat.class_id" class="b-t">
					<td>
						<div class="class-name">{{ stat.class_name }}</div>
						<div
							v-if="stat.teachers && stat.teachers.length > 0"
							class="text-muted"
							style="margin-top: -0.5rem"
						>
							{{ teacherNames(stat) }}
						</div>
					</td>
					<!-- <td class="text-center score-num">{{stat.uns}}</td>
					<td class="text-center score-num">{{stat.rel}}</td>
					<td class="text-center score-num">{{stat.res}}</td>
					<td class="text-center score-num">{{stat.com}}</td>
					<td class="text-center score-num">{{stat.tot}}</td>-->
					<td style="width: 70%">
						<div class="progress" style="height: 1.5rem">
							<hide-overflow
								v-if="stat.non > 0"
								class="progress-bar non-bar clickable"
								:click="
									() => {
										loadDetails(stat, 0);
									}
								"
								role="progressbar"
								:style="{ width: `${stat.nonPer}%` }"
								v-tippy
								:title="
									`No work submitted: ${fs.fixed1d(stat.nonPer)}% (${stat.non} out of ${stat.size})`
								"
								height="1.5rem"
								>NONE</hide-overflow
							>
							<hide-overflow
								v-if="stat.uns > 0"
								class="progress-bar uns-bar clickable"
								:click="
									() => {
										loadDetails(stat, 1);
									}
								"
								role="progressbar"
								:style="{ width: `${stat.unsPer}%` }"
								v-tippy
								:title="`Unscored: ${fs.fixed1d(stat.unsPer)}% (${stat.uns} out of ${stat.size})`"
								height="1.5rem"
								>UNSCORED</hide-overflow
							>
							<hide-overflow
								v-if="stat.rel > 0"
								class="progress-bar rel-bar clickable"
								:click="
									() => {
										loadDetails(stat, 2);
									}
								"
								role="progressbar"
								:style="{ width: `${stat.relPer}%` }"
								v-tippy
								:title="`Scored once: ${fs.fixed1d(stat.relPer)}% (${stat.rel} out of ${stat.size})`"
								height="1.5rem"
								>SCORED ONCE</hide-overflow
							>
							<hide-overflow
								v-if="stat.res > 0"
								class="progress-bar res-bar clickable"
								:click="
									() => {
										loadDetails(stat, 3);
									}
								"
								role="progressbar"
								:style="{ width: `${stat.resPer}%` }"
								v-tippy
								:title="`Resolution: ${fs.fixed1d(stat.resPer)}% (${stat.res} out of ${stat.size})`"
								height="1.5rem"
								>RESOLUTION</hide-overflow
							>
							<hide-overflow
								v-if="stat.com > 0"
								class="progress-bar com-bar clickable"
								:click="
									() => {
										loadDetails(stat, 10);
									}
								"
								role="progressbar"
								:style="{ width: `${stat.comPer}%` }"
								v-tippy
								:title="`Complete: ${fs.fixed1d(stat.comPer)}% (${stat.com} out of ${stat.size})`"
								height="1.5rem"
								>COMPLETE</hide-overflow
							>
						</div>
					</td>
				</tr>
			</table>

			<h2 v-if="assessmentID && (!stats || stats.length == 0)" class="text-very-muted text-center mt-4 mb-0">
				No results for this assessment
			</h2>
			<h2 v-if="!assessmentID" class="text-very-muted text-center mt-4 mb-0">
				Please choose an assessment
			</h2>
		</div>

		<b-modal
			:visible="details != null"
			:header-bg-variant="details && getModalVariant(details)"
			ok-only
			@ok="closeModal"
		>
			<template v-if="details" slot="modal-header">
				<h5 v-if="details.state == 0" class="modal-title pl-2">
					No Work Submitted<span v-if="details.students" class="ml-2">({{ details.students.length }})</span>
				</h5>
				<h5 v-if="details.state == 1" class="modal-title pl-2">
					Unscored<span v-if="details.students" class="ml-2">({{ details.students.length }})</span>
				</h5>
				<h5 v-if="details.state == 2" class="modal-title pl-2">
					Scored Once<span v-if="details.students" class="ml-2">({{ details.students.length }})</span>
				</h5>
				<h5 v-if="details.state == 3" class="modal-title pl-2">
					Resolution<span v-if="details.students" class="ml-2">({{ details.students.length }})</span>
				</h5>
				<h5 v-if="details.state == 10" class="modal-title pl-2">
					Complete<span v-if="details.students" class="ml-2">({{ details.students.length }})</span>
				</h5>
			</template>
			<div v-if="!details || !details.students" style="min-height: 10rem;">
				<loading type="page" />
			</div>
			<div v-if="details && details.students" class="p-2">
				<div class="mb-2">
					<span class="_600">Assessment:</span
					><span class="text-muted ml-1">{{ getAssessmentName(this.assessmentID) }}</span>
				</div>
				<div class="mb-2">
					<span class="_600">Class:</span><span class="text-muted ml-1">{{ details.class_name }}</span>
				</div>
				<div class="_600 mb-2">Students:</div>
				<table class="table striped condensed-table">
					<tr v-for="student in details.students" :key="student.id">
						<td>{{ student.full_name }}</td>
						<td>({{ student.ref_id }})</td>
					</tr>
				</table>
			</div>
		</b-modal>
	</div>
</template>

<style scoped>
a {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a:hover {
	opacity: 1;
}
table {
	width: 100%;
}
.w65 {
	min-width: 65px;
}
.class-name {
	font-size: 1.25rem;
}
i {
	opacity: 1;
}
.non-bar {
	background-color: #dc3545aa;
	border: 2px solid #dc3545;
	min-width: 10px;
}
.non-bar:hover {
	background-color: #dc3545dd;
}
.com-bar {
	background-color: #22b66eaa;
	border: 2px solid #22b66e;
	min-width: 10px;
}
.com-bar:hover {
	background-color: #22b66edd;
}
.uns-bar {
	background-color: #bd63bfaa;
	border: 2px solid #bd63bf;
	min-width: 10px;
}
.uns-bar:hover {
	background-color: #bd63bfdd;
}
.rel-bar {
	background-color: #4968e7aa;
	border: 2px solid #4968e7;
	min-width: 10px;
}
.rel-bar:hover {
	background-color: #4968e7dd;
}
.res-bar {
	background-color: #49c3e7aa;
	border: 2px solid #49c3e7;
	min-width: 10px;
}
.res-bar:hover {
	background-color: #49c3e7dd;
}

.clickable {
	cursor: pointer;
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import ConfigService from "@/services/ConfigService";
import ConfigSelect from "@/components/ConfigSelect";
import HideOverflow from "@/components/HideOverflow";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";
import Notie from "@/services/NotieService";
import store from "@/services/Store";
import fs from "@/services/FormatService";

export default {
	name: "SchoolDashProgress",

	props: ["districtID", "schoolID"],

	components: { ConfigSelect, HideOverflow },

	data() {
		let assessmentID = store.getDefault(this, "dash.school.progress.assessment_id", null);
		return {
			fs: fs,
			busy: false,
			stats: [],
			assessments: [],
			assessmentID: assessmentID,

			details: null
		};
	},
	created() {
		this.loadData();

		ConfigService.listAssessments()
			.then(r => {
				this.assessments = r.data.assessments;
				_.each(this.assessments, asmt => {
					asmt.name = asmt.ref_id + " • " + asmt.name;
				});
			})
			.catch(e => {
				console.log(e);
				Notie.error("Failed to get assessments", e);
			});
	},
	watch: {
		schoolID() {
			this.loadData();
		},
		assessmentID() {
			store.set(this, "dash.school.progress.assessment_id", this.assessmentID);
			this.loadData();
		}
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			console.log("Get completion classes");
			if(this.assessmentID){
				ReportingService.getSchoolProgress(this.districtID, this.schoolID, this.assessmentID)
					.then(resp => {
						this.stats = _.sortBy(resp.data.classes, "class_name");
						_.each(this.stats, stat => {
							stat.non = stat.size - stat.tot;
							stat.nonPer = (100 * stat.non) / stat.size;
							stat.unsPer = (100 * stat.uns) / stat.size;
							stat.relPer = (100 * stat.rel) / stat.size;
							stat.resPer = (100 * stat.res) / stat.size;
							stat.comPer = (100 * stat.com) / stat.size;
						});
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.busy = false;
					});
			}
		},

		teacherNames(clazz) {
			let teacherNames = _.map(clazz.teachers, t => t.full_name);
			return teacherNames.join(", ");
		},

		loadDetails(stat, state) {
			this.details = stat;
			this.details.state = state;
			this.$forceUpdate();

			ReportingService.getCompletionDetailList(
				this.districtID,
				this.schoolID,
				this.assessmentID,
				stat.class_id,
				state
			)
				.then(resp => {
					this.details.students = resp.data;
					this.$forceUpdate();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load details", err);
				});
		},

		getModalVariant(details) {
			switch (details.state) {
				case 0:
					return "danger";
					break;
				case 1:
					return "secondary";
					break;
				case 2:
					return "info";
					break;
				case 3:
					return "primary";
					break;
				default:
					return "success";
					break;
			}
		},

		closeModal() {
			this.details = null;
		},

		getAssessmentName(id) {
			let asmt = _.find(this.assessments, { id: id });
			if (asmt) {
				return asmt.name;
			}
			return "(Unknown)";
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/school_dashboard/SchoolDashProgress.vue